import { render, staticRenderFns } from "./choice-tickets.vue?vue&type=template&id=321ff4e0&scoped=true&"
import script from "./choice-tickets.vue?vue&type=script&lang=js&"
export * from "./choice-tickets.vue?vue&type=script&lang=js&"
import style0 from "./choice-tickets.vue?vue&type=style&index=0&id=321ff4e0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321ff4e0",
  null
  
)

export default component.exports